// Module-level caches that hold one signed-in user's data (an order's shipments, a quote's
// order chain). Each is made with sessionMap() so clearAuth() can empty them all when the
// user signs out or another user signs in - before, they survived until a page reload
// (2026-10-31, the second-sign-in leftover).
const caches = new Set();

export function sessionMap() {
  const m = new Map();
  caches.add(m);
  return m;
}

export function clearSessionCaches() {
  caches.forEach((m) => m.clear());
}
